<template>
  <div
    v-show="isActive"
    class="grid-module__filter table-menu enhancify grid-module social-media-image-template"
  >
    <div class="columns">
      <div class="column">
        <form>
          <section class="modern-form-group">
            <div class="modern-input-labeled">
              <label for="paymentStatus" style="white-space: nowrap">User</label>
              <UserTypeSelect v-model="filters.userTypeIds" />
            </div>

            <div class="modern-input-labeled">
              <label for="paymentStatus" style="white-space: nowrap">Social Media</label>
              <ModernSelect
                v-model.number="filters.socialMediaId"
                optionLabelKey="value"
                optionValueKey="id"
                :options="socialMediaFilterOptions"
              />
            </div>

            <div class="modern-input-labeled">
              <label for="paymentStatus" style="white-space: nowrap">Content type</label>
              <ModernSelect
                v-model.number="filters.contentTypeId"
                optionLabelKey="value"
                optionValueKey="id"
                :options="socialMediaContentTypeFilterOptions"
              />
            </div>

            <div class="modern-input-labeled">
              <label for="paymentStatus" style="white-space: nowrap">Theme</label>
              <ThemeSelect
                v-model="filters.themeIds"
                :themes="themes"
                :user-type-ids="filters.userTypeIds"
              />
            </div>
          </section>
        </form>
      </div>

      <div
        class="column is-2 btn-flex sm-hide"
        style="display: flex; justify-content: flex-end; min-width: 180px; gap: .75em;"
      >
        <b-button
          v-if="hasAccessToModifyMarketingMaterials"
          class="modern-button"
          style="max-width: 160px; width: 160px; margin-top: .75em; flex-grow: 1"
          @click="onAdd"
        >
          ADD IMAGE
        </b-button>
      </div>
    </div>

    <div class="grid-module__grid">
      <b-table
        :data="socialMediaImageTemplates"
        :loading="tableIsLoading"
        :default-sort="[defaultSort, defaultSortDirection]"
        :total="total"
        :per-page="perPage"
        :current-page.sync="page"
        paginated
        hoverable
        sticky-header
        backend-sorting
        backend-pagination
        class="bordered-table"
        @page-change="onPageChange"
        @sort="onSort"
        ref="tbl"
      >
        <template v-slot="props">
          <b-table-column
            label="Name"
            width="15%"
            field="name"
            sortable
          >
            <template #header="column">
              <div class="enhtableth" :class=column.column.thclass>
                <span class="enhlabel">{{ column.column.label }}</span>
              </div>
            </template>

            <span class="cell__value">{{ props.row.name }}</span>
          </b-table-column>

          <b-table-column
            label="Social Media"
            width="10%"
            field="socialMediaValue"
            sortable
          >
            <template #header="column">
              <div class="enhtableth" :class=column.column.thclass>
                <span class="enhlabel">{{ column.column.label }}</span>
              </div>
            </template>

            <span class="cell__value">{{ props.row.socialMedia.value }}</span>
          </b-table-column>

          <b-table-column
            label="Content Type"
            width="10%"
            field="contentTypeValue"
            sortable
          >
            <template #header="column">
              <div class="enhtableth" :class=column.column.thclass>
                <span class="enhlabel">{{ column.column.label }}</span>
              </div>
            </template>

            <span class="cell__value">{{ props.row.contentType.value }}</span>
          </b-table-column>

          <b-table-column
            label="Theme"
            width="10%"
            field="themeName"
            sortable
          >
            <template #header="column">
              <div class="enhtableth" :class=column.column.thclass>
                <span class="enhlabel">{{ column.column.label }}</span>
              </div>
            </template>

            <span class="cell__value">{{ props.row.theme.name }}</span>
          </b-table-column>

          <b-table-column
            label="User"
            width="15%"
            field="userTypeValue"
            sortable
          >
            <template #header="column">
              <div class="enhtableth" :class=column.column.thclass>
                <span class="enhlabel">{{ column.column.label }}</span>
              </div>
            </template>

            <span class="cell__value">
                <template v-if="props.row.userType.id !== 111">
                  Customer:
                </template>
                {{ props.row.userType.value }}
              </span>
          </b-table-column>

          <b-table-column
            label="Order"
            width="6%"
            sortable
            field="order"
            style="text-align: right;"
          >
            <template #header="column">
              <div class="enhtableth" :class=column.column.thclass>
                <span class="enhlabel">{{ column.column.label }}</span>
              </div>
            </template>

            <span class="cell__value">{{ props.row.order }}</span>
          </b-table-column>

          <b-table-column
            label="Last edit date"
            width="10%"
            field="lastEditDate"
            sortable
          >
            <template #header="column">
              <div class="enhtableth" :class=column.column.thclass>
                <span class="enhlabel">{{ column.column.label }}</span>
              </div>
            </template>

            <span class="cell__value">{{ props.row.lastEditDate | lastEditDateFilter }}</span>
          </b-table-column>

          <b-table-column
            label="Last editor"
            width="16%"
            field="lastEditor"
            sortable
          >
            <template #header="column">
              <div class="enhtableth" :class=column.column.thclass>
                <span class="enhlabel">{{ column.column.label }}</span>
              </div>
            </template>

            <span class="cell__value">
                {{ props.row.lastEditor ? props.row.lastEditor.email : '' }}
              </span>
          </b-table-column>

          <b-table-column
            :visible="hasAccessToModifyMarketingMaterials"
            class="cell"
            width="4%"
            cell-class="action-data-column"
          >
            <div class="actions-wrapper">
                <span
                  title="Edit image"
                  class="icon is-success action-button"
                  @click="onEdit(props.row)"
                >
                  <i class="fas fa-pencil-alt fa-lg" />
                </span>

              <span
                title="Delete image"
                class="icon is-success action-button"
                @click="onRemove(props.row)"
              >
                  <i class="far fa-trash-alt fa-lg" />
                </span>
            </div>
          </b-table-column>
        </template>

        <template v-slot:bottom-left>
          <b-field
            ref="perPageField"
            label="Per page"
            horizontal
            style="margin-right: 1rem"
            class="enh-per-page"
          >
            <b-select
              v-model="perPage"
              :disabled="socialMediaImageTemplates.length === 0"
            >
              <option
                v-for="perPageOption in perPageOptions"
                :key="perPageOption"
                :value="perPageOption"
                :selected="perPageOption === perPage"
              >{{ perPageOption }}
              </option>
            </b-select>
          </b-field>
        </template>

        <template slot="empty">
          <div
            v-if="socialMediaImageTemplates.length === 0"
            class="columns is-centered"
            style="margin: 0;"
          >
            <div class="column is-half enh-disabled has-text-centered">
              <b-icon pack="fal" icon="frown" size="is-large"></b-icon>
              <p>Nothing here</p>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapMutations, mapState } from 'vuex';
import { remove, search } from '@/api/social_media_image_templates';
import SocialMediaImageTemplateForm from
  '@/views/Manage/Settings/MarketingMaterials/SocialMediaImageTemplate/SocialMediaImageTemplateForm.vue';
import ModernSelect from '@/components/ModernSelect.vue';
import { get } from 'lodash';
import { MARKETING_MATERIALS_MANAGE_MODIFY } from '@/const/privileges';
import * as MUTATIONS from '@/store/mutations';
import restoreScrollToElementAfterAction from '@/utils/restoreScrollToElementAfterAction';
import { search as searchThemes } from '@/api/marketing_materials_theme';
import UserTypeSelect from '@/views/Manage/Settings/components/Select/UserTypeSelect.vue';
import ThemeSelect from '@/views/Manage/Settings/components/Select/ThemeSelect.vue';

export default {
  name: 'SocialMediaImages',
  components: { ThemeSelect, UserTypeSelect, ModernSelect },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {
        userTypeIds: null,
        socialMediaId: null,
        contentTypeId: null,
        themeIds: null,
      },
      themes: [],
      socialMediaImageTemplates: [],
      tableIsLoading: false,
      sortField: 'order',
      sortOrder: 'asc',
      defaultSort: 'order',
      defaultSortDirection: 'asc',
      total: 0,
      perPage: 25,
      perPageOptions: [10, 25, 50, 100],
      page: 1,
    };
  },
  filters: {
    lastEditDateFilter(value) {
      return (new Date(value)).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    },
  },
  computed: {
    ...mapGetters(['hasAccess']),
    ...mapState('constant', ['socialMedias', 'socialMediaContentTypes']),
    socialMediaFilterOptions() {
      return [{ id: null, value: 'Any' }, ...this.socialMedias];
    },
    socialMediaContentTypeFilterOptions() {
      return [{ id: null, value: 'Any' }, ...this.socialMediaContentTypes];
    },
    hasAccessToModifyMarketingMaterials() {
      return this.hasAccess(
        MARKETING_MATERIALS_MANAGE_MODIFY,
        MARKETING_MATERIALS_MANAGE_MODIFY,
        true,
      );
    },
  },
  watch: {
    isActive() {
      this.load();
      this.loadThemes();
    },
    'filters.userTypeIds': function filtersUserTypeIds() {
      if (this.filters.themeIds === null) {
        this.load();
      } else {
        this.filters.themeIds = null;
      }
    },
    'filters.socialMediaId': function filtersSocialMediaId() {
      this.load();
    },
    'filters.contentTypeId': function filtersContentTypeId() {
      this.load();
    },
    'filters.themeIds': function filtersThemeIds() {
      this.load();
    },
    async perPage() {
      await restoreScrollToElementAfterAction(this.doSearch, this.$refs.perPageField.$el);
    },
  },
  methods: {
    ...mapMutations({
      startLoading: MUTATIONS.START_LOADING,
      finishLoading: MUTATIONS.FINISH_LOADING,
    }),
    async onPageChange(page) {
      this.page = page;
      await restoreScrollToElementAfterAction(this.load, this.$refs.perPageField.$el);
    },
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.load();
    },
    async onAdd() {
      this.openSocialMediaImageTemplateForm();
    },
    onEdit(row) {
      this.openSocialMediaImageTemplateForm(row.id);
    },
    openSocialMediaImageTemplateForm(id = null) {
      const self = this;
      this.$buefy.modal.open({
        parent: this,
        component: SocialMediaImageTemplateForm,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'modern-fix-modal',
        canCancel: ['outside'],
        props: { id, themes: self.themes },
        events: {
          async submit() {
            await self.load();
          },
        },
      });
    },
    async onRemove(row) {
      const searchFn = this.doSearch;
      this.$buefy.dialog.confirm({
        title: 'Deleting image',
        message: 'Are you sure you want to <b>delete</b> this image? This action cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        ariaModal: true,
        async onConfirm() {
          try {
            await remove(row.id);
            this.$buefy.toast.open({ message: 'Delete successful!', type: 'is-success', duration: 3000 });
            await searchFn();
          } catch (error) {
            this.$buefy.snackbar.open({
              type: 'is-danger',
              message: get(error, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com'),
              position: 'is-top',
              indefinite: true,
              actionText: ' ',
            });
          }
        },
      });
    },
    async doSearch() {
      this.page = 1;
      await this.load();
    },
    async load() {
      if (this.isActive) {
        this.startLoading();
        this.tableIsLoading = true;

        try {
          const payload = {
            page: this.page,
            limit: this.perPage,
            order: `${this.sortOrder === 'desc' ? '-' : '+'}${this.sortField}`,
            ...this.filters,
          };

          const response = await search(payload);

          this.socialMediaImageTemplates = response.data.data;
          this.total = response.data.total;
        } catch (e) {
          this.$buefy.snackbar.open({
            message: 'Something wrong',
            actionText: ' ',
            position: 'is-top',
            indefinite: true,
            type: 'is-danger',
          });
        }

        this.tableIsLoading = false;
        this.finishLoading();
      }
    },
    async loadThemes() {
      this.startLoading();

      try {
        const themeResponse = await searchThemes();
        this.themes = themeResponse.data;
      } catch (e) {
        this.$buefy.toast.open({
          message: 'Something wrong',
          type: 'is-danger',
          duration: 5000,
        });
      }

      this.finishLoading();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "~@/assets/style/views/Manage/Settings/table.styl";
</style>
